var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('content-body',{attrs:{"article":_vm.article,"article-list":_vm.articleList,"selected-article":_vm.selectedArticle,"route-context":_vm.routeContext,"on-article-select":_vm.onArticleSelect,"force-highlighting":_vm.whiteboardView,"paragraphs-numbered":_vm.paragraphsNumbered}})
}
var staticRenderFns = []

export { render, staticRenderFns }